import { IntegrityMonitorAddCustomRulePanelWebComponent } from '../component/IntegrityMonitorAddCustomRulePanelWebComponent';
import { IntegrityMonitorAddCustomRulePanelView } from '../view/IntegrityMonitorAddCustomRulePanelView';
import { template } from '../view/template';
import { BaseWebComponentController, IListenerConfig } from '../../../../../framework/BaseWebComponentController';
import { IntegrityMonitorCustomRuleRepository } from '../repository/IntegrityMonitorCustomRuleRepository';
import { CustomRuleFormData, CustomRuleFormEvents } from '../types';
import { showErrorToast, showSuccessToast } from '@nirvana/shared/common';

export class IntegrityMonitorAddCustomRulePanelController extends BaseWebComponentController {
  public component!: IntegrityMonitorAddCustomRulePanelWebComponent;
  public view!: IntegrityMonitorAddCustomRulePanelView;
  public dataRepository: IntegrityMonitorCustomRuleRepository;

  public assign: boolean;
  public ruleSetId: string;

  public editForm: boolean;
  public editId: string;

  constructor(component: IntegrityMonitorAddCustomRulePanelWebComponent) {
    super(component);

    this.assign = false;
    this.ruleSetId = '';

    this.editForm = false;
    this.editId = '';

    this.initialSetup({
      viewConstructor: IntegrityMonitorAddCustomRulePanelView,
      viewTemplate: template,
      dataRepositoryConstructor: IntegrityMonitorCustomRuleRepository,
    });
  }

  computeEventListeners(): IListenerConfig[] {
    return [
      {
        element: this.view.dom.$cancelButton,
        event: 'click',
        callback: this.closePanel,
      },
      {
        element: this.view.dom.$saveButton,
        event: 'click',
        callback: this.save,
      },
    ];
  }

  private async save(): Promise<void> {
    this.view.dom.$saveButton?.setLoadingState(true);

    try {
      await this.saveRule();
    } catch (e) {
      console.warn(e);
    } finally {
      this.view.dom.$saveButton?.setLoadingState(false);
    }
  }

  private async saveRule(): Promise<void> {
    if (!this.view.dom.$ruleForm.valid) {
      return;
    }

    const record: Object = this.view.dom.$ruleForm.value;

    record['companyId'] = this.dependencies.getActiveCompany().companyId;

    try {
      if (this.editForm) {
        record['_id'] = this.editId;
        await this.dataRepository.updateRule(record as CustomRuleFormData);
        showSuccessToast(this.view.successfulUpdateMessage);
        this.closePanel();

        this.component.dispatchEvent(
          new CustomEvent(CustomRuleFormEvents.CUSTOM_RULE_SAVED, {
            bubbles: true,
          })
        );
      } else {
        const createResult = await this.dataRepository.createRule(record as CustomRuleFormData);
        if (this.assign && createResult) {
          await this.dataRepository.assignRulesToRuleSets(record['companyId'], createResult['data'], [this.ruleSetId]);
        }

        showSuccessToast(this.view.successfulSaveMessage);
        this.closePanel();

        this.component.dispatchEvent(
          new CustomEvent(CustomRuleFormEvents.CUSTOM_RULE_SAVED, {
            bubbles: true,
          })
        );
      }
    } catch (error) {
      if (error?.exceptionType === 'Exceptions\\AuthenticationSecurityException') {
        return;
      }

      showErrorToast(error);
    }
  }

  private closePanel() {
    this.component.isVisible = false;
    this.view.dom.$ruleForm.reset();
  }
}
